import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ActivatedRoute } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { AppState } from '../../core.state';
import { authLoginSuccess } from '../auth.actions';
import { createUser } from '../auth.models';
import { selectAuthError } from '../auth.selectors';

@Component({
  selector: 'rpe-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LoginComponent implements OnInit {
  error$: Observable<string | null>;

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.error$ = this.store.pipe(select(selectAuthError));
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['returnUrl']) {
        let ru: string = params['returnUrl'];
        const rus = ru.split('?');
        if (rus.length == 2) {
          let ut = rus[1].split('&');
          if (ut.length >= 2) {
            this.authLoginSuccess(ut[0].split('=')[1], ut[1].split('=')[1]);
          }
        }
      } else {
        if (params['token']) {
          this.authLoginSuccess(params['id'], params['token']);
        }
      }
    });
  }

  authLoginSuccess(id: string, token: string) {
    let user = createUser();
    user.id = Number(id);
    user.token = token;
    this.store.dispatch(authLoginSuccess({ user: user }));
  }

  idpLogin() {
    window.location.href = `${environment.backendUrl}/oauthclient/login/1`;
  }
}
